module.exports = __webpack_public_path__ + "assets/img/page_1.67668317.png";